import { render, staticRenderFns } from "./LimitSelect.vue?vue&type=template&id=5b573a22&scoped=true"
import script from "./LimitSelect.vue?vue&type=script&lang=js"
export * from "./LimitSelect.vue?vue&type=script&lang=js"
import style0 from "./LimitSelect.vue?vue&type=style&index=0&id=5b573a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b573a22",
  null
  
)

export default component.exports